import React from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// core components
import GridContainer from 'components/MaterialKit/Grid/GridContainer.js';
import GridItem from 'components/MaterialKit/Grid/GridItem.js';
import CardHeader from 'components/MaterialKit/Card/CardHeader.js';


import makeStyles from '@mui/styles/makeStyles';

import descriptionStyle from 'assets/jss/nextjs-material-kit-pro/pages/aboutUsSections/descriptionStyle.js';

const useStyles = makeStyles(descriptionStyle);

export default function SectionDescription() {
    const classes = useStyles();
    return (
        <div className={classNames(classes.aboutDescription)}>
            <a className={classes.anchor} id='the-project'  />
            <h2 className={classes.title}>The Project</h2>
            <GridContainer>
                <GridItem
                    xs={12}
                    md={6}
                    className={classNames(classes.mrAuto, classes.mlAuto)}
                >
                    <h5 className={classes.description}>
            In order to protect the environment and safety of the communities
            living near mine sites, we have received funding from industry
            partners to develop a meaningful monitoring programme for preventing
            the failure of tailings storage facilities (TSFs). The project is
            part of the AMIRA Global’s Future Tailings program and benefits from
            the technological and financial support of a number of major, minor
                    </h5>
                    <h5 className={classes.description}>
            We are evaluating a range of monitoring technologies and their
            suitability for application to providing advance warning of
            potential TSFs instabilities. The outcomes of this project provide
            meaningful insight into appropriately selected instrumentation that
            measure meaningful parameters. These measurements will act as
            trigger warnings for detecting the potential onset of failures that
            may be prevented.
                    </h5>
                    <h5 className={classes.description}>
            Given that the recently launched Global Industry Standard on
            Tailings Management, under the guidance of the United Nations
            Environment Programme (UNEP), the International Council on Mining
            and Metals (ICMM) and the Principles for Responsible Investment
            (PRI), listed tailings monitoring as one of its six core topics, our
            project outcomes are expected to have wide-ranging impacts and
            benefits across the industry internationally.
                    </h5>
                </GridItem>
                <GridItem
                    xs={12}
                    md={6}
                    className={classNames(classes.mrAuto, classes.mlAuto)}
                >
                    <CardHeader image plain>
                        <img src={require('assets/img/avo-inSar-Slope-failure.png')} alt="..." />
                    </CardHeader>
                </GridItem>
            </GridContainer>
        </div>
    );
}
